import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { setNotification } from "../api/dataSlice"
import { isMobileApp, sendDataToMobileApp } from "./Utilities"

export default function NotificationListener() {

    const dispatch = useDispatch()
    const { DEBUG } = window.conf

    const onPushData = (event) => {
        const payload = event.detail
        DEBUG && console.log(`[NotificationListener] Incoming notification from mobile app: ${JSON.stringify(payload)}`)
        dispatch(setNotification(payload))
        isMobileApp && sendDataToMobileApp({ type: "removeNotification" })
    }

    useEffect(() => {
        window.addEventListener("pushData", onPushData)
        return () => window.removeEventListener("pushData", onPushData)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return null
}